import { render, staticRenderFns } from "./EditSong.vue?vue&type=template&id=5aa223c9&"
import script from "./EditSong.vue?vue&type=script&lang=js&"
export * from "./EditSong.vue?vue&type=script&lang=js&"
import style0 from "./EditSong.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditSong.vue"
export default component.exports